
// File categories used throughout the application
export const fileCategories = [
  { value: "documents", label: "Πρότυπες μελέτες" },
  { value: "videos", label: "Εκπαιδευτικά Video" },
  { value: "guides", label: "Goto Οδηγίες" },
  { value: "webinars", label: "Webinars" },
  { value: "qa", label: "Q&A" }
];

// Helper function to find category label
export const getCategoryLabel = (value: string) => {
  const category = fileCategories.find(cat => cat.value === value);
  return category ? category.label : value;
};
